import mdiSvg from './mdi-svg';
import md from './md';
import mdi from './mdi';
import fa from './fa';
import fa4 from './fa4';
export default Object.freeze({
    mdiSvg: mdiSvg,
    md: md,
    mdi: mdi,
    fa: fa,
    fa4: fa4
});
//# sourceMappingURL=index.js.map